import type { FC } from 'react';
import { useContext } from 'react';
import pipeSource from '@epimodev/callbag-doki/utils/pipe';
import scan from '@epimodev/callbag-doki/operators/scan';

import ConfigContext from 'app/common/ConfigContext';
import { isEbattle } from 'app/config/videogameSpecific.config.helper';
import { loadLiveMatchData } from 'app/utils/api';
import { mergeMatchLiveData } from 'app/utils/entities/match';
import { useSubscription } from 'app/hooks/useSubscription';

import EBattleNameBlock from './EBattleNameBlock';
import MatchScore from './MatchScore';
import MatchTitle from './MatchTitle';

interface Props {
  data: NameBlockMatch;
}

const NameBlock: FC<Props> = ({ data: initialData }) => {
  const { customer } = useContext(ConfigContext);

  const { data: liveData } = useSubscription(
    () =>
      pipeSource(
        loadLiveMatchData(initialData.id, customer),
        scan((acc, message) => mergeMatchLiveData(acc, message), initialData)
      ),
    [],
    {
      prevent: initialData.match_status === 'finished'
    }
  );

  const data = liveData || initialData;

  const hasScore =
    data.games.some(game => game.status === 'finished' || game.status === 'running') ||
    data.match_status === 'finished';

  if (isEbattle(data.videogame_slug)) {
    return <EBattleNameBlock data={data} />;
  }

  if (hasScore) {
    return <MatchScore data={data} />;
  }

  return <MatchTitle data={data} />;
};

NameBlock.displayName = 'NameBlock';

export default NameBlock;
